function getHiddenHeight(el, width) {
    if (!(el === null || el === void 0 ? void 0 : el.cloneNode)) {
        return null;
    }
    var clone = el.cloneNode(true);
    Object.assign(clone.style, {
        overflow: 'visible',
        height: 'auto',
        maxHeight: 'none',
        opacity: '0',
        visibility: 'hidden',
        display: 'block',
        width: "".concat(width, "px"),
    });
    el.after(clone);
    var height = clone.offsetHeight;
    clone.remove();
    return height;
}
/**
 * Thank you Louis Hoebregts
 * https://css-tricks.com/how-to-animate-the-details-element-using-waapi/
 */
var DetailsAnimation = /** @class */ (function () {
    function DetailsAnimation(el, content, options) {
        var _this = this;
        var _a;
        this.animationOptions = {
            duration: 200,
            easing: 'ease-out',
        };
        // Store the <details> element
        this.el = el;
        // Store the <summary> element
        this.summary = el.querySelector('summary');
        // Store the <div class="content"> element
        this.content = content;
        // Store the animation object (so we can cancel it if needed)
        this.animation = null;
        // Store if the element is closing
        this.isClosing = false;
        // Store if the element is expanding
        this.isExpanding = false;
        this.animationOptions =
            options !== undefined
                ? Object.assign({}, this.animationOptions, options)
                : this.animationOptions;
        // Detect user clicks on the summary element
        (_a = this.summary) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function (e) { return _this.onClick(e); });
    }
    DetailsAnimation.prototype.onClick = function (e) {
        // Stop default behavior from the browser
        e.preventDefault();
        // Add an overflow on the <details> to avoid content overflowing
        this.content.style.overflow = 'hidden';
        // Check if the element is being closed or is already closed
        if (this.isClosing || !this.el.open) {
            this.open();
            // Check if the element is being opened or is already open
        }
        else if (this.isExpanding || this.el.open) {
            this.shrink();
        }
    };
    DetailsAnimation.prototype.shrink = function () {
        var _this = this;
        // Set the element as "being closed"
        this.isClosing = true;
        // Store the current height of the element
        var startHeight = "".concat(this.content.offsetHeight, "px");
        // Calculate the height of the summary
        var endHeight = "0";
        // If there is already an animation running
        if (this.animation) {
            // Cancel the current animation
            this.animation.cancel();
        }
        // Start a WAAPI animation
        this.animation = this.content.animate({
            // Set the keyframes from the startHeight to endHeight
            height: [startHeight, endHeight],
        }, this.animationOptions);
        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = function () { return _this.onAnimationFinish(false); };
        // If the animation is cancelled, isClosing variable is set to false
        this.animation.oncancel = function () { return (_this.isClosing = false); };
    };
    DetailsAnimation.prototype.open = function () {
        var _this = this;
        // Apply a fixed height on the element
        this.content.style.height = "".concat(this.content.offsetHeight, "px");
        // Force the [open] attribute on the details element
        this.el.open = true;
        // Wait for the next frame to call the expand function
        window.requestAnimationFrame(function () { return _this.expand(); });
    };
    DetailsAnimation.prototype.expand = function () {
        var _this = this;
        var _a, _b;
        // Set the element as "being expanding"
        this.isExpanding = true;
        // Get the current fixed height of the element
        var startHeight = "0";
        // Calculate the open height of the element (summary height + content height)
        var endHeight = "".concat((_b = getHiddenHeight(this.content, (_a = this.el.offsetWidth) !== null && _a !== void 0 ? _a : 0)) !== null && _b !== void 0 ? _b : 0, "px");
        // If there is already an animation running
        if (this.animation) {
            // Cancel the current animation
            this.animation.cancel();
        }
        // Start a WAAPI animation
        this.animation = this.content.animate({
            // Set the keyframes from the startHeight to endHeight
            height: [startHeight, endHeight],
        }, this.animationOptions);
        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = function () { return _this.onAnimationFinish(true); };
        // If the animation is cancelled, isExpanding variable is set to false
        this.animation.oncancel = function () { return (_this.isExpanding = false); };
    };
    DetailsAnimation.prototype.onAnimationFinish = function (open) {
        // Set the open attribute based on the parameter
        this.el.open = open;
        // Clear the stored animation
        this.animation = null;
        // Reset isClosing & isExpanding
        this.isClosing = false;
        this.isExpanding = false;
        // Remove the overflow hidden and the fixed height
        this.content
            ? (this.content.style.height = this.content.style.overflow = '')
            : null;
    };
    return DetailsAnimation;
}());

export { DetailsAnimation };
//# sourceMappingURL=index.es.mjs.map
